export function setDim(state, payload) {
    state.dimmed = payload;
}

export function setLock(state, payload) {
    if (state.locked === payload) {
        return;
    }
    if (payload) {
        state.scrollPos = {
            x: window.scrollX,
            y: window.scrollY,
        };
        document.querySelector('.site').style.top = -state.scrollPos.y + 'px';
        state.locked = payload;
    } else {
        state.locked = payload;
        document.querySelector('.site').style.top = 'auto';

        setTimeout(() => {
            window.scrollTo({
                top: state.scrollPos.y,
                left: state.scrollPos.x,
            });
        }, 15);
    }
}

export function setUser(state, payload) {
    state.user = payload;
}

export function setTrees(state, payload) {
    state.trees = payload;
}

export function setOrganisation(state, payload) {
    state.organisation = payload;
}

export function clearActiveTree(state) {
    state.activeTree.links.data.forEach((val, key) => {
        if (
            !Object.prototype.hasOwnProperty.call(val, 'slug') ||
            val.slug === false
        ) {
            console.log(state.activeTree.links.data);
            state.activeTree.links.data.splice(key, 1);
        }
    });
}

export function setActiveTree(state, payload) {
    state.activeTree = payload;
}
export function setActiveTreeOrder(state, payload) {
    state.activeTree.reverse_link_order = payload;
}

export function setActiveTreeLinks(state, payload) {
    state.activeTree.links.data = payload;
}

export function setManipulatedData(state, payload) {
    state.manipulatedData = payload;
}

export function setMobileNav(state, payload) {
    state.isMobileNav = payload;
}
